enum PersistenceStatus {
  SAVING,
  INITIAL_ERROR,
  UNRECOVERABLE_ERROR,
  NO_ERROR,
  UNRECOVERABLE_NETWORK_ERROR,
}

export default PersistenceStatus;
